<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN ParaOverride-1" id="_idParaDest-3"> </p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/1979TitleType1.jpg"/>
</div>
</div>
<p class="BT1_Body_text_1_Full-out ParaOverride-5"><img alt="" class="_idGenObjectAttribute-2" src="image/L-1.jpg"/></p>
<p class="BT1_Body_text_1_Full-out ParaOverride-6">Atlantic Mon<span class="HPh3_Highlighted_phrase_3">thly Press</span></p>
<p class="BT1_Body_text_1_Full-out ParaOverride-6"><span class="CharOverride-2">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802159038-2.vue?0f130f4e